import React from 'react';
import styled from '@emotion/styled';
import { WidgetProps } from '@rjsf/utils';
import Datepicker from '../../Datepicker/Datepicker';
import LabelValue from '../../LabelValue';
import DateTimeDisplay from '../../DateTimeDisplay';

const DateTimeUTCWidget = ({ label, value, required, disabled, className, onChange, readonly }: WidgetProps) => {
  const formatUTC = (dateInt: Date | string, addOffset = false) => {
    const offsetDate = dateInt instanceof Date ? dateInt : new Date(dateInt);
    const offset = addOffset ? offsetDate.getTimezoneOffset() : -offsetDate.getTimezoneOffset();
    offsetDate.setTime(offsetDate.getTime() + offset * 60000);
    return offsetDate;
  };

  const handleChange = (date: any) => {
    onChange(formatUTC(date).toISOString());
  };

  return readonly ? (
    <LabelValue label={label}>
      <DateTimeDisplay missingText="-" singleLine>
        {value}
      </DateTimeDisplay>
    </LabelValue>
  ) : (
    <Adornment adorn={+!!(value && value.length > 0)}>
      <Datepicker
        label={label}
        value={value && `${formatUTC(value, true)}`}
        onChange={(date) => handleChange(date)}
        required={required || false}
        disabled={disabled || false}
        error={false}
        showTimeSelect
        timeIntervals={15}
        timeCaption="Time"
        className={className}
      />
    </Adornment>
  );
};

export default DateTimeUTCWidget;

const Adornment = styled.div<{ adorn: number }>`
  position: relative;
  display: inline-block;

  ${({ adorn }) =>
    adorn &&
    `
  .react-datepicker__input-container:after {
    content: 'UTC';
    position: absolute;
    left: 9rem;
    content: 'UTC';
    pointer-events: none;
    opacity: 0.6;
    line-height: 1.34;
    top: auto;
    bottom: 0;
  }
  
  `}
`;
